export default __webpack_public_path__ + "assets/images/54387d207fd3c1f7083c3dfcc94c3dec.svg";